var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRisika({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "441px",
    height: "115px",
    viewBox: "0 0 441 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-blue",
    fill: "#54BDCB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.414,3.646 C72.692919,1.28718589 58.8001939,0.067692543 44.878,2.84217094e-14 C30.9561386,0.0677156902 17.0637476,1.28720907 3.343,3.646 C1.40982141,3.98376933 -0.000612128931,5.66253543 -4.48308069e-16,7.625 L-4.48308069e-16,69.655 C-2.64697796e-23,85.62 10.882,92.61 18.269,98.964 C24.276,104.131 38.107,111.714 43.069,114.364 C44.2006315,114.970053 45.5603685,114.970053 46.692,114.364 C51.652,111.71 65.483,104.127 71.492,98.964 C78.875,92.61 89.757,85.62 89.757,69.655 L89.757,7.625 C89.7576121,5.66253543 88.3471786,3.98376933 86.414,3.646 Z M44.878,63.552 C40.3371432,63.553618 36.2425088,60.819517 34.5036769,56.6247766 C32.764845,52.4300362 33.7243063,47.6008775 36.9346049,44.3894346 C40.1449036,41.1779916 44.97372,40.2168094 49.1690798,41.9541462 C53.3644396,43.6914831 56.0999997,47.7851429 56.1,52.326 C56.1000004,58.5243868 51.0763864,63.5497914 44.878,63.552 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-white",
    transform: "translate(143.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.956,31.567 C61.956,15.191 50.856,5.818 31.573,5.818 L0.973,5.818 L0.973,81.235 L13.686,81.235 L13.686,58.5 L31.571,58.5 C32.756,58.5 33.941,58.5 35.019,58.392 L48.809,81.233 L63.247,81.233 L46.334,56.024 C56.353,52.146 61.956,43.634 61.956,31.567 Z M31.573,47.082 L13.688,47.082 L13.688,17.238 L31.573,17.238 C43.209,17.238 49.889,21.979 49.889,31.891 C49.889,42.126 43.209,47.082 31.573,47.082 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 78.118,
    y: 23.918,
    width: 12.282,
    height: 57.318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.259,0 C82.2825716,-0.0170372718 80.3868432,0.782889335 79.0200602,2.2106371 C77.6532771,3.63838487 76.9367855,5.56719494 77.04,7.541 C76.9642073,10.1697254 78.3233237,12.6318636 80.5880739,13.968594 C82.8528242,15.3053244 85.6651758,15.3053244 87.9299261,13.968594 C90.1946763,12.6318636 91.5537927,10.1697254 91.478,7.541 C91.5812145,5.56719494 90.8647229,3.63838487 89.4979398,2.2106371 C88.1311568,0.782889335 86.2354284,-0.0170372718 84.259,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.473,39 C116.473,34.9 120.029,33.289 124.873,33.289 C130.713932,33.5184188 136.394679,35.2635839 141.357,38.353 L145.882,29.195 C140.711,25.532 133.061,23.377 125.843,23.377 C114.853,23.377 104.726,28.333 104.726,39.969 C104.618,60.655 134.785,54.083 134.785,65.827 C134.785,70.136 130.691,71.968 125.412,71.968 C119.163,71.968 111.19,69.274 106.234,64.857 L101.817,73.692 C107.527,78.863 116.469,81.664 124.873,81.664 C136.401,81.664 146.852,76.385 146.852,64.641 C146.963,43.85 116.473,49.56 116.473,39 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.494,0 C163.517653,-0.0170537727 161.622014,0.782903034 160.255386,2.21068634 C158.888758,3.63846965 158.172499,5.56729176 158.276,7.541 C158.194012,10.1735251 159.551637,12.6419379 161.818787,13.982439 C164.085936,15.3229402 166.903064,15.3229402 169.170213,13.982439 C171.437363,12.6419379 172.794988,10.1735251 172.713,7.541 C172.816512,5.56711672 172.10012,3.63813485 170.733272,2.21031941 C169.366424,0.782503981 167.47052,-0.0173312417 165.494,-3.55271368e-15 L165.494,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 159.353,
    y: 23.918,
    width: 12.282,
    height: 57.318
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "242.421 23.918 228.199 23.918 202.881 49.56 202.881 1.293 190.49 1.293 190.49 81.235 202.881 81.235 202.881 65.182 212.577 54.947 229.385 81.235 244.037 81.235 221.196 46.112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,81.235 L297.692,43.635 C297.584,31.035 289.292,23.488 274.528,23.488 C263.646,23.488 257.828,25.966 249.856,30.706 L254.919,39.325 C260.63,35.447 266.34,33.508 271.834,33.508 C280.885,33.508 285.517,37.817 285.517,45.036 L285.517,46.76 L268.173,46.76 C254.382,46.867 246.517,53.547 246.517,63.998 C246.517,74.126 254.274,81.775 266.664,81.775 C274.964,81.775 281.532,79.297 285.626,74.233 L285.626,81.233 L297.8,81.235 Z M285.518,61.088 C284.872,67.337 278.084,71.97 269.25,71.97 C262.355,71.97 258.15,68.63 258.15,63.458 C258.15,57.958 261.92,55.809 270.001,55.809 L285.515,55.809 L285.518,61.088 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRisika);
export default __webpack_public_path__ + "static/media/logo-risika.d69aeea813ec082a518ab362a3524dcc.svg";
export { ForwardRef as ReactComponent };